import { render } from "./GetInTouch.vue?vue&type=template&id=6a427c91&scoped=true"
import script from "./GetInTouch.vue?vue&type=script&lang=js"
export * from "./GetInTouch.vue?vue&type=script&lang=js"

import "./GetInTouch.vue?vue&type=style&index=0&id=6a427c91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a427c91"]])

export default __exports__